/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SecurityExchangeTransactionType {
    ISSUE = 'ISSUE',
    TRANSFER = 'TRANSFER',
}
